import { Fragment, ReactElement } from 'react';

import { Grid } from '@breathelife/mui';
import { Language } from '@breathelife/types';
import { RenderingAgreeField, RenderingField } from '@zinnia/form-engine-sdk';

import usePdfContext from '../../../Context/usePdfContext';
import { QuestionAnswerGroupA } from '../../PdfComponents/ComponentVariants/ComponentVariantsA/Styles/PdfQuestionAnswerGroupA';

type Props = {
  field: RenderingField;
};

export function AgreeField(props: Props): ReactElement | null {
  const { field } = props;
  const { application } = usePdfContext();

  const locale = application.lang;
  const agreeFieldValue =
    typeof field.title !== 'undefined' ? field.title : locale === Language.fr ? 'Je confirm' : 'I confim';

  return (
    <Fragment>
      <Grid item xs={12} key={field.id} data-testid='AgreeField'>
        <QuestionAnswerGroupA
          fieldText={(field as RenderingAgreeField).modalText}
          value={agreeFieldValue}
          valueWidth={6}
        />
      </Grid>
    </Fragment>
  );
}
